import React, { useState } from 'react';
import { X, Send } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useMessages } from '../contexts/MessagesContext';
import { useToast } from './Toast';
interface ProgramRequestModalProps {
  onClose: () => void;
  onSubmit: (data: {
    details: string;
  }) => void;
}
export function ProgramRequestModal({
  onClose,
  onSubmit
}: ProgramRequestModalProps) {
  const [details, setDetails] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const {
    addConversation
  } = useMessages();
  const {
    showToast
  } = useToast();
  const handleSubmit = () => {
    if (details.trim()) {
      setIsSubmitting(true);
      // Simulate API call with setTimeout
      setTimeout(() => {
        // Create a new conversation for the program request
        const newConversation = {
          id: Date.now().toString(),
          type: 'program' as const,
          title: 'Haftalık Program Talebiniz',
          preview: details.substring(0, 50) + (details.length > 50 ? '...' : ''),
          status: 'waiting' as const,
          date: 'Şimdi',
          unread: true,
          recipient: {
            id: 'guidance-service',
            name: 'Rehberlik Servisi',
            role: 'Akademik Danışman'
          },
          messages: [{
            id: 'm1',
            sender: 'student' as const,
            content: details,
            timestamp: `Bugün, ${new Date().getHours().toString().padStart(2, '0')}:${new Date().getMinutes().toString().padStart(2, '0')}`
          }]
        };
        // Add the new conversation
        addConversation(newConversation);
        // Call the onSubmit callback
        onSubmit({
          details
        });
        // Show success toast notification
        showToast('✅ Talebiniz alınmıştır, en kısa sürede dönüş yapılacaktır.', 'success');
        // Close the modal
        onClose();
        // Navigate to Messages page
        navigate('/messages');
        setIsSubmitting(false);
      }, 1000); // Simulate network delay
    }
  };
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50 overflow-y-auto" data-id="element-821">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-xl" data-id="element-822">
        <div className="relative bg-black/90 rounded-xl" data-id="element-823">
          <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-824">
            <h2 className="text-xl font-bold" data-id="element-825">Haftalık Ders Programı Talebi</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" disabled={isSubmitting} data-id="element-826">
              <X className="w-6 h-6" data-id="element-827" />
            </button>
          </div>
          <div className="p-6 space-y-6" data-id="element-828">
            <p className="text-gray-300" data-id="element-829">
              Sana en uygun haftalık ders programını hazırlayabilmemiz için
              lütfen mevcut durumunu, hedeflerini ve özellikle ağırlık vermek
              istediğin dersleri aşağıdaki alana detaylıca yaz.
            </p>
            <div className="space-y-2" data-id="element-830">
              <textarea value={details} onChange={e => setDetails(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-3 min-h-[200px] focus:ring-2 ring-purple-500/20" placeholder="Hedeflerin, günlük çalışma potansiyelin ve zorlandığın konular gibi detayları ekleyebilirsin..." disabled={isSubmitting} data-id="element-831" />
            </div>
          </div>
          <div className="p-4 border-t border-gray-800 flex justify-end gap-3" data-id="element-832">
            <button onClick={onClose} className="px-4 py-2 bg-transparent border border-gray-700 hover:bg-white/5 text-gray-300 rounded-lg transition-colors" disabled={isSubmitting} data-id="element-833">
              İptal
            </button>
            <button onClick={handleSubmit} className="px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg hover:from-purple-700 hover:to-indigo-700 transition-colors flex items-center gap-2" disabled={isSubmitting || !details.trim()} data-id="element-834">
              {isSubmitting ? <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-835">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-836"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-837"></path>
                  </svg>
                  Gönderiliyor...
                </> : <>
                  <Send className="w-4 h-4" data-id="element-838" />
                  Program Talebini Gönder
                </>}
            </button>
          </div>
        </div>
      </div>
    </div>;
}